
import { defineComponent, PropType } from "vue";
import { Order } from "@/data/order";
import UserService from "@/services/UserService";
import { formatDate } from "@/utils/helpers";
import EventBusService from "@/services/EventBusService";

interface OrderWithLoading extends Order {
    loading: boolean,
}

declare interface UserOrdersModalData {
    loading: boolean,
    shownLocal: boolean,
    orders: Array<OrderWithLoading>,
}

export default defineComponent({
    name: 'UserOrdersModal',
    components: {

    },
    emits: [
        'close',
    ],
    props: {
        shown: {
            type: Boolean,
            required: true,
        },
    },
    data(): UserOrdersModalData {
        return {
            loading: false,
            shownLocal: true,
            orders: [] as Array<OrderWithLoading>, // type required again for type hinting (?)
        };
    },
    methods: {
        formatDate,
        loadData() {
            if( this.loading ) {
                return;
            }

            this.loading = true;
            return UserService.getOrders().then(result => {
                return this.orders = result.data.data.map((order: Order) => ({
                    ...order,
                    loading: false,
                }));
            }).finally(() => this.loading = false);
        },
        downloadInvoice(order: OrderWithLoading) {
            if( order.loading ) {
                return false;
            }

            order.loading = true;
            return UserService.generateOrderInvoiceDownloadLink(order.id).then(async (result) => {
                console.log('Opening ', result.data.downloadUrl);
                (this.$refs.downloadLink as HTMLElement).setAttribute('href', result.data.downloadUrl);
                await this.$nextTick();
                (this.$refs.downloadLink as HTMLElement).click();
            }).catch(error => {
                EventBusService.$notification({
                    type: 'error',
                    message: error.response.data?.error || 'Beim Herunterladen der Rechnung ist ein Fehler aufgetreten.',
                });
                console.log(error.response.data);
            }).finally(() => order.loading = false);
        },
        closeModal() {
            this.$emit('close');
        },
    },
    watch: {
        shown: {
            handler(val) {
                if( val ) {
                    this.loadData();
                }

                this.shownLocal = val;
            },
            immediate: true,
        },
    },
    mounted() {
        /*this.$watch('shown', (newShown: boolean) => {
            if( newShown ) {
                console.log('tmp SHOW MODAL RegionProductsModal');
            }
        });*/
    },
});
